angular.module('impactx.address').controller('AddressDialogCtrl', [
    '$scope',
    '$mdDialog',
    'dataGen',
    '$mdToast',
    'TranslationService',
    'data',
    'trns',
    'label_title',
    'addressType',
    'typesAvail',
    'showInheritanceOptions',
    'owningComOptions',
    'disableOwningCom',
    'saveDirect',
    'personalData',
    'addresses',
    'restricted',
    'regionCode',
    AddressDialogCtrl
]);

function AddressDialogCtrl($scope, $mdDialog, dataGen, $mdToast, TranslationService, data, trns, label_title, addressType, typesAvail,
                           showInheritanceOptions, owningComOptions, disableOwningCom, saveDirect, personalData, addresses, restricted,
                           regionCode) {
    var ADDRESS_SIZE = 'BASIC_DIALOG';
    
    $scope.data = {};
    $scope.trns = trns;
    $scope.label_title = label_title;
    $scope.addressType = addressType;
    $scope.typesAvail = typesAvail;
    $scope.showInheritanceOptions = showInheritanceOptions;
    $scope.data.adr = data;
    $scope.owningComOptions = owningComOptions;
    $scope.disableOwningCom = disableOwningCom;
    $scope.saveDirect = saveDirect;
    $scope.personalData = personalData;
    $scope.addresses = addresses;
    $scope.restricted = restricted;
    $scope.regionCode = regionCode;

    $scope.disableList = [];
    function checkInUse() {
        $scope.disableList = [];
        if($scope.data.adr.inUseByCompany) {
            $scope.disableList.push($scope.trns.addressInUseByCompany);
        }
        if($scope.data.adr.inUseByUser) {
            $scope.disableList.push($scope.trns.addressInUseByUser);
        }
    }

    var ctrl = this;

    $scope.closeDialog = function(answer) {
        $mdDialog.hide(answer);
    };

    $scope.addressIsEmpty = function() {
        var adr;

        if ($scope.data && $scope.data.adr) 
        {
            adr = $scope.data.adr;
            return (adr.name1.value == undefined &&
                    adr.name2.value == undefined &&
                    adr.name3.value == undefined &&
                    adr.street1.value == undefined &&
                    adr.zip.value == undefined &&
                    adr.city.value == undefined) &&
                    adr.eMail.value == undefined;
        } else {
            return false;
        }
    };

    $scope.anyTypesAvail = function()
    {
        var avail = $scope.typesAvail;
        return avail.handover || avail.delivery || avail.invoice || avail.contact;
    };

    var setStandardType = function()
    {
        switch($scope.addressType) {
            case 'handover':
                $scope.data.adr.isHandoverAddress.value = true;
                break;
            case 'contact':
                $scope.data.adr.isContactAddress.value = true;
                break;
            case 'invoice':
                $scope.data.adr.isInvoiceAddress.value = true;
                break;
            case 'delivery':
                $scope.data.adr.isDeliveryAddress.value = true;
        }
    };

    this.handleNuts = function () {
        var address,
            scope = {};

        address = $scope.data.adr;

        if (address.zip && address.country.selected) {
            return dataGen.postAsForm(scope, {
                zip: address.zip.value,
                ctyId: address.country.selected.id
            }, "/address/ziptonuts").then(function () {
                var bestNuts, availableNuts, currentNuts;

                currentNuts = address.nutsCode;
                bestNuts = scope.data.bestCode;
                availableNuts = scope.data.options;

                if ((currentNuts && availableNuts.indexOf(currentNuts) !== -1) || !address.nuts) {
                    address.nutsCode.value = bestNuts;
                }
                $scope.availableNuts = availableNuts;
            });
        }
    };

    this.savePageData = function(saveCopy) {
        var adr = $scope.data.adr;
        if(!(impactX.isDefined(adr, "isContactAddress.value") ||
                impactX.isDefined(adr, "isHandoverAddress.value") ||
                impactX.isDefined(adr, "isDeliveryAddress.value") ||
                impactX.isDefined(adr, "isInvoiceAddress.value")))
        {

            setStandardType();
        }
        var dataObj = {address: $scope.data.adr, regionCode: regionCode};
        $scope.data.adr.addressSize = ADDRESS_SIZE;
        if (saveDirect)
        {
            var entryPoint = saveCopy ? "/address/saveasuser" : "/address/saveuser";
            // 'saveDirect' is only used in profile and basket, which both create user addresses
            var tmp = {};
            dataGen.postAsForm(tmp, dataObj, entryPoint).then(function(){
                $scope.closeDialog(tmp.data.data.adr);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(TranslationService.get('saveSuccess'))
                        .position("bottom right")
                        .hideDelay(10000)
                );
            })
        }
        else
        {
            dataObj.copy = saveCopy;
            dataGen.postAsForm($scope, dataObj, "/address/format").then(function ()
            {
                $scope.closeDialog($scope.data.adr);
            })
        }
    };

    this.checkVisible = function(field){
        if(field) {
            return field.visible || false;
        }
        return false;
    };

    this.checkRequired = function (field) {
        if (field) {
            if (field.showMust) {
                return true;
            }
            if ($scope.data.adr.isContactAddress.value) {
                return field.requiredIfContactAddress ||
                    ($scope.personalData && field.requiredIfContactAddressAndPersonalData)
            }
        }
        return false;
    }

    ctrl.copyFromAddress = function () {
        if ($scope.addresses && $scope.addresses.selected) {
            const oldAdr = $scope.data.adr;
            $scope.data.adr = angular.copy($scope.addresses.selected);
            $scope.data.adr.isSingleUse = oldAdr.isSingleUse;
            $scope.data.adr.hasRightToEdit = oldAdr.hasRightToEdit;
            $scope.data.adr.noInheritDelivery = oldAdr.noInheritDelivery;
            $scope.data.adr.isHandoverAddress = oldAdr.isHandoverAddress;
            $scope.data.adr.isDeliveryAddress = oldAdr.isDeliveryAddress;
            $scope.data.adr.isInvoiceAddress = oldAdr.isInvoiceAddress;
            $scope.data.adr.isContactAddress = oldAdr.isContactAddress;

            $scope.data.adr.addressId = 0;
            $scope.data.adr.companyRelation = undefined;
            $scope.data.adr.owningCom = undefined;
            $scope.data.adr.userRelation = undefined;

            if ($scope.data.adr.room) {
                $scope.data.adr.room.value = '';
            }

            if ($scope.data.adr.floor) {
                $scope.data.adr.floor.value = '';
            }
        }
    };


    if($scope.data.adr == undefined || $scope.data.adr == null) {
        var entrypoint = saveDirect ? '/address/viewuser' : '/address/view';
        dataGen.getData($scope, {id: 0, size: ADDRESS_SIZE}, entrypoint).then(function() {
            setStandardType();
            ctrl.handleNuts();
            checkInUse();
            if ($scope.data.adr.autoOwningCom) {
                $scope.data.adr.autoOwningCom.value = $scope.owningComOptions;
            }
        });
        $scope.data.adr = data;
    }
    else{
        setStandardType();
        ctrl.handleNuts();
        checkInUse();
    }
}